export default function PrivacyPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://sotomago.com';

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'プライバシーポリシー - ソトマゴ',
    description: 'ソトマゴのプライバシーポリシーページです。',
    url: `${siteUrl}/privacy`,
    inLanguage: 'ja',
    isPartOf: {
      '@type': 'WebSite',
      name: 'ソトマゴ',
      url: siteUrl
    }
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-brand-dark mb-12 text-center">プライバシーポリシー</h1>
          
          <div className="bg-white rounded-2xl shadow-lg p-8 space-y-8">
            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-bold text-brand-dark mb-3">個人情報の取り扱いについて</h2>
              <p className="text-gray-700 leading-relaxed">
                ソトマゴ(以下「当社」)は、お客様の個人情報および健康・生活に関する情報の保護を重要な責務と考え、個人情報保護法その他関連法令を遵守し、以下のプライバシーポリシー(以下「本ポリシー」)に基づき適切に管理・運用いたします。
              </p>
            </div>

            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-bold text-brand-dark mb-3">1. 個人情報の定義</h2>
              <p className="text-gray-700 leading-relaxed">
                本ポリシーにおいて「個人情報」とは、個人情報保護法第2条第1項に定める情報を指し、氏名、住所、連絡先、生年月日、健康状態、生活状況、介護に関する情報など、特定の個人を識別できる情報をいいます。
              </p>
            </div>

            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-bold text-brand-dark mb-3">2. 個人情報の収集方法</h2>
              <p className="text-gray-700 leading-relaxed">
                当社は、サービス提供に必要な範囲で、以下の情報を取得する場合があります。
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-gray-700">
                <li>氏名、住所、電話番号、メールアドレス</li>
                <li>年齢、生年月日</li>
                <li>健康状態や身体状況に関する情報</li>
                <li>ご希望のサポート内容、生活状況に関する情報</li>
                <li>利用履歴、予約内容、相談内容</li>
                <li>緊急連絡先やご家族の連絡先 等</li>
              </ul>
            </div>

            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-bold text-brand-dark mb-3">3. 個人情報の利用目的</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                収集した個人情報は、以下の目的のために利用いたします。
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>サポートサービス(外出支援・生活支援・健康サポート等)の提供</li>
                <li>サービス提供に必要な事前確認・ヒアリング</li>
                <li>ご家族への報告業務</li>
                <li>お問い合わせ・相談への対応</li>
                <li>サービスの品質向上および安全な運営のため</li>
                <li>お客様への連絡および案内のため</li>
                <li>利用規約等に違反する行為への対応</li>
                <li>上記に付随する目的</li>
              </ul>
            </div>

            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-bold text-brand-dark mb-3">4. 個人情報の第三者提供</h2>
              <p className="text-gray-700 leading-relaxed">
                当社は、以下の場合を除き、ご本人の同意なく個人情報を第三者に提供しません。
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-gray-700">
                <li>法令に基づく場合</li>
                <li>人の生命・身体・財産の保護のために必要がある場合</li>
                <li>公衆衛生の向上のため特に必要がある場合</li>
                <li>国・自治体またはその委託先が法令に基づく事務を行うため協力が必要な場合</li>
                <li>緊急時(事故・体調急変等)にご家族および医療機関へ情報提供が必要な場合</li>
              </ul>
            </div>

            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-bold text-brand-dark mb-3">5. 安全管理措置</h2>
              <p className="text-gray-700 leading-relaxed">
                当社は、個人情報への不正アクセス、紛失、破壊、改ざん、漏洩等を防止するため、必要かつ適切な安全管理措置を講じます。また、従業員に対しても適切な監督および教育を行い、情報管理体制の強化に努めます。
              </p>
            </div>

            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-bold text-brand-dark mb-3">6. 個人情報の開示・訂正・削除</h2>
              <p className="text-gray-700 leading-relaxed">
                お客様ご本人から、個人情報の開示、訂正、追加、削除、利用停止等の請求があった場合、法令に基づき速やかに対応いたします。ご希望の場合は、下記お問い合わせ先までご連絡ください。
              </p>
            </div>

            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-bold text-brand-dark mb-3">7. プライバシーポリシーの変更</h2>
              <p className="text-gray-700 leading-relaxed">
                本ポリシーは、必要に応じて内容を改訂する場合があります。変更後のプライバシーポリシーは、当社ウェブサイトに掲載した時点で効力を生じます。
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-brand-dark mb-3">8. お問い合わせ</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                個人情報に関するお問い合わせは、以下までお願いいたします。
              </p>
              <div className="bg-amber-50 rounded-lg p-4 space-y-2">
                <p className="text-gray-700">
                  <strong className="text-brand-dark">事業者名：</strong>ソトマゴ
                </p>
                <p className="text-gray-700">
                  <strong className="text-brand-dark">所在地：</strong>〒680-0035 鳥取県鳥取市新町214
                </p>
                <p className="text-gray-700">
                  <strong className="text-brand-dark">電話番号：</strong>
                  <a href="tel:+817090045641" className="hover:text-brand-yellow transition-colors duration-300 cursor-pointer">
                    070-9004-5641
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <a
              href="/#hero"
              className="inline-flex items-center text-brand-dark hover:text-brand-yellow transition-colors duration-300 font-medium cursor-pointer"
            >
              <i className="ri-arrow-left-line mr-2"></i>
              トップページに戻る
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
